import React, { useCallback, useEffect, useState } from 'react';
import './TagBox.scss';
import TagForm from './TagForm';

//React.memo를 사용하여 tag값이 바뀔 때만 리렌더링되도록 처리
const TagItem = React.memo(({ tag, onRemove }) => (
  <span className="Tag" onClick={() => onRemove(tag)}>
    #{tag}
  </span>
));

const TagList = React.memo(({ tags, onRemove }) => (
  <div className="TagList">
    {tags.map((tag) => (
      <TagItem key={tag} tag={tag} onRemove={onRemove} />
    ))}
  </div>
));

const TagBox = ({ tags, onChangeTags }) => {
  const [input, setInput] = useState('');
  const [localTags, setLocalTags] = useState([]);

  const insertTag = useCallback(
    //localTags가 바뀔 때만 함수를 새로 만들고, 그 외엔 이전 함수를 재사용
    (tag) => {
      if (!tag) return; //빈 문자열일 경우 추가x
      if (localTags.includes(tag)) return; //이미 존재하는 태그면 추가x
      const nextTags = [...localTags, tag];
      setLocalTags(nextTags); //기존 태그 배열에 새 태그 추가
      onChangeTags(nextTags);
    },
    [localTags, onChangeTags], //localTags가 바뀔 때만 함수 재생성
  );

  const onRemove = useCallback(
    (tag) => {
      const nextTags = localTags.filter((t) => t !== tag);
      setLocalTags(nextTags);
      onChangeTags(nextTags);
    },
    [localTags, onChangeTags],
  );

  const onChange = useCallback((e) => {
    setInput(e.target.value);
  }, []);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      insertTag(input.trim()); //앞뒤 공백을 없앤 후 등록
      setInput(''); //input 초기화
    },
    [input, insertTag],
  );

  //tags 값이 바뀔 때
  useEffect(() => {
    setLocalTags(tags);
  }, [tags]);

  return (
    <div className="TagBox">
      <h4>태그</h4>
      <TagForm onSubmit={onSubmit}>
        <input
          placeholder="태그를 입력하세요"
          value={input}
          onChange={onChange}
        />
        <button type="submit">추가</button>
      </TagForm>
      <TagList tags={localTags} onRemove={onRemove} />
    </div>
  );
};

export default TagBox;
